import { deserialize, serialize } from 'serializr';
import { AxiosError } from 'axios';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from '../../routes/routeConstants/apiRoutes';
import { NotificationTypes } from '../../enums/notificationTypes';
import Notification from '../../shared/components/Notification/index';
import { homeServiceMessages } from './home.constants';
import { DashboardServicesResponse, DashboardSettings } from '../../models/dashboard.model';

export const getAxiosErrorMessage = (error: unknown): string | undefined => {
  const axiosError = error as AxiosError<{ message?: string }>;
  return axiosError?.response?.data?.message || axiosError?.message;
};

export const notifyHomeService = (type: NotificationTypes, message?: string) => {
  Notification({
    message: message || homeServiceMessages.DEFAULT_ERROR,
    description: '',
    type,
  });
};

export const fetchDashboardServices = async (): Promise<DashboardServicesResponse> => {
  try {
    const { data } = await axiosInstance.get(ApiRoutes.DASHBOARD_SERVICES);
    return deserialize(DashboardServicesResponse, data);
  } catch (error) {
    notifyHomeService(NotificationTypes.ERROR, getAxiosErrorMessage(error));
    throw error;
  }
};

export const fetchDashboardSettings = async (): Promise<DashboardSettings> => {
  try {
    const { data } = await axiosInstance.get(ApiRoutes.DASHBOARD_SETTINGS);
    return deserialize(DashboardSettings, data);
  } catch (error) {
    notifyHomeService(NotificationTypes.ERROR, getAxiosErrorMessage(error));
    throw error;
  }
};

export const saveDashboardSettings = async (settings: DashboardSettings): Promise<{ message: string }> => {
  const { data } = await axiosInstance.put(ApiRoutes.DASHBOARD_SETTINGS, serialize(DashboardSettings, settings));
  return data;
};
